/* tslint:disable */
/* eslint-disable */
/**
 * View API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { CreateBlockCommonFromJSON, CreateBlockCommonToJSON } from './CreateBlockCommon';

/**
 * 
 * @export
 * @interface UpdateBlockInView
 */

/**
 * Check if a given object implements the UpdateBlockInView interface.
 */
export function instanceOfUpdateBlockInView(value) {
  if (!('block' in value) || value['block'] === undefined) return false;
  if (!('zoneRID' in value) || value['zoneRID'] === undefined) return false;
  return true;
}
export function UpdateBlockInViewFromJSON(json) {
  return UpdateBlockInViewFromJSONTyped(json, false);
}
export function UpdateBlockInViewFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    'block': CreateBlockCommonFromJSON(json['block']),
    'zoneRID': json['zoneRID'],
    'zoneId': json['zoneId'] == null ? undefined : json['zoneId'],
    'viewId': json['viewId'] == null ? undefined : json['viewId'],
    'containerRID': json['containerRID'] == null ? undefined : json['containerRID'],
    'plugins': json['plugins'] == null ? undefined : json['plugins']
  };
}
export function UpdateBlockInViewToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    'block': CreateBlockCommonToJSON(value['block']),
    'zoneRID': value['zoneRID'],
    'zoneId': value['zoneId'],
    'viewId': value['viewId'],
    'containerRID': value['containerRID'],
    'plugins': value['plugins']
  };
}